import "moment/locale/en-gb";
import moment from "moment";

import { useSelector } from "react-redux";
import { RootState } from "./redux/store";
import { useEffect } from "react";
import { SliceCallState } from "./slices/sliceCallState";

interface MomentWrapperProps {
  children: React.ReactNode;
}

export const MomentWrapper = (props: MomentWrapperProps) => {
  const { loading, settings } = useSelector((state: RootState) => state.settings);

  useEffect(() => {
    if (loading === SliceCallState.succeeded) {
      const webAppCulture = settings?.webApp.localization.defaultCulture;
      const globalsCulture = settings?.globals.localization.defaultCulture;
      const culture = webAppCulture ? webAppCulture : globalsCulture;

      if (culture) {
        moment.locale(culture.toLowerCase());
      }
    }
  }, [loading, settings]);

  return <>{props.children}</>;
};
